import Vue from "vue";
import router from "../../router";

//set Headers payload
const authHeader = process.env.VUE_APP_REQUEST_HEADER;
const headers = {};
headers[authHeader] = process.env.VUE_APP_HUB_API_KEY;

export default {
    namespaced: true,
    state: () => ({
       priceConfiguratorCountries: [],
       loadingPricesConfigurator: false,
       pricesConfigurator: []
    }),
    mutations: {
      loadConfiguratorPriceCountries(state, items) {
        state.priceConfiguratorCountries = items.map((item) => item.country)
      },
      setLoadingPriceConfigurator(state, item) {
        state.loadingPricesConfigurator = item
      },
      loadPricesConfigurator(state, items) {
        state.pricesConfigurator = items
      },
      updatePricesConfigurator(state, payload) {
        const idx = state.pricesConfigurator.findIndex(price => price.id_model == payload.id_model)
        if (idx != -1) {
            state.pricesConfigurator[idx].price_panel = payload.price_panel
            state.pricesConfigurator[idx].price_panel_frame = payload.price_panel_frame
            state.pricesConfigurator[idx].price_gate_pedestrian = payload.price_gate_pedestrian
            state.pricesConfigurator[idx].price_gate_swing = payload.price_gate_swing
            state.pricesConfigurator[idx].price_gate_swing_bifold = payload.price_gate_swing_bifold
            state.pricesConfigurator[idx].price_gate_slide = payload.price_gate_slide
            state.pricesConfigurator[idx].price_gate_slide_telescopic = payload.price_gate_slide_telescopic
            state.pricesConfigurator[idx].price_gate_slide_articulated = payload.price_gate_slide_articulated
            state.pricesConfigurator[idx].price_gate_selfsupport = payload.price_gate_selfsupport
        }
      }
    },
    actions: {
      async fetchConfiguratorPriceCountries({ commit }) {
        commit("setLoadingPriceConfigurator", true);
        await Vue.http
          .get(process.env.VUE_APP_HUB_API_HOST + "api/productie/preturi-configurator/countries", {
            headers: headers,
          })
          .then(function (response) {
            commit("loadConfiguratorPriceCountries", response.body);
            commit("setLoadingPriceConfigurator", false);
          })
          .catch(function (error) {
            console.error(error.body.message);
            commit("setLoadingPriceConfigurator", false);
          });

      },
      fetchPricesConfigurator({ commit }, country) {
        commit("setLoadingPriceConfigurator", true);
        Vue.http.get(process.env.VUE_APP_HUB_API_HOST + "api/productie/preturi-configurator/" + country, {
            headers: headers
          })
          .then(response => {
            commit("loadPricesConfigurator", response.body);
            commit("setLoadingPriceConfigurator", false);
          })
          .catch(error => {
            console.log(error);
            commit("setLoadingPriceConfigurator", false);
          });
      },
      editPricesConfigurator({ commit }, payload) {
        commit("setLoadingPriceConfigurator", true);
        Vue.http.put(process.env.VUE_APP_HUB_API_HOST + "api/productie/preturi-configurator/edit", payload, {
            headers: headers
          })
          .then(response => {
            router.push({ query: M.toast( { html: response.body, classes: "bg-green-500" }) });
            commit("updatePricesConfigurator", payload);
            commit("setLoadingPriceConfigurator", false);
          })
          .catch(error => {
            console.log(error);
            commit("setLoadingPriceConfigurator", false);
          });
    }
    }
}